type ls = typeof localStorage;
import ddt from '@wix/da-ddt';

const fakeCache = {};
let fakeCachedUsed = false;

class LocalStorageWrapper implements ls {
  clear() {
    try {
      window.localStorage.clear();
    } catch (e) {
      ddt.error('localStorage', e);
    }
  }

  setItem(key: string, value: any) {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {
      fakeCache[key] = value;
      fakeCachedUsed = true;
      ddt.error('localStorage', e);
    }
  }

  getItem(key: string) {
    try {
      if (fakeCachedUsed) {
        return fakeCache[key] || window.localStorage.getItem(key);
      }
      return window.localStorage.getItem(key);
    } catch (e) {
      ddt.error('localStorage', e);
      return null;
    }
  }

  key(index: number) {
    try {
      return window.localStorage.key(index);
    } catch (e) {
      ddt.error('localStorage', e);
      return null;
    }
  }

  removeItem(key: string) {
    try {
      return window.localStorage.removeItem(key);
    } catch (e) {
      ddt.error('localStorage', e);
      return null;
    }
  }

  get length() {
    return window.localStorage.length;
  }
}

export default new LocalStorageWrapper();
